import moment from 'moment';
import { PARTITION_STATUSES, PartitionStatus } from '~/api/partitionArchive';

export const l = (key: string): string => `resources.partitionArchive.${key}`;

export const partitionArchivePath = '/partitionArchive';
export const partitionsPath = `${partitionArchivePath}/partitions`;

// partition boundaries are UTC midnights: shown as short dates ("1 Oct 2026") in UTC - in the tenant's or
// the browser's time zone they would shift by a day west of UTC; `to` is exclusive, shown as the last
// included day
export const formatPartitionFrom = (from: string): string => moment.utc(from).format('ll');

export const formatPartitionTo = (to: string): string =>
  moment.utc(to).subtract(1, 'millisecond').format('ll');

// statuses from the start of a partition's life (live) to its end (archived), as the newest-first partition list
export const statusesNewestFirst: PartitionStatus[] = [...PARTITION_STATUSES].reverse();

export const formatNumber = (value: number): string => value.toLocaleString('en-US');
